<template>
  <v-select
    ref="controlFocoSelectBanco"
    label="Banco*"
    v-model="iModel"
    :items="items"
    item-value="Id_Banco"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectBanco",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      rutaApi: "Banco/",
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        let ind = this.items.findIndex(x => x.Id_Banco == valor);
        this.$emit("seleccionarItem", this.items[ind]);
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectBanco", this.setearFoco);
    this.listarItems();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectBanco", this.setearFoco);
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        palabra: ""
      })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      this.$refs.controlFocoSelectBanco.focus();
    }
  }
};
</script>
